<div data-test="yjxDGo1j" class="subheader" data-sticky>
  <div data-test="JLEJHRoq" class="subheader__container modules-container">
    <div data-test="TxgGbemm" class="subheader__wrap row">
      <div data-test="NUbdXhSd" class="col-auto mr-auto">
        <ng-content></ng-content>
      </div>
      <div
        data-test="lJGGgdN8"
        class="col-auto pr-0 d-flex align-items-center"
        style="gap: 0.5rem"
      >
        <ng-content select="[subheader-actions]"></ng-content>
        <span data-test="9IwjUafl" *ngIf="showAddBtn" class="subheader__add">
          <button
            data-test="AZItSsfd"
            class="button button_primary button_floating"
            (click)="add()"
          >
            <i data-test="r99btNpo" class="material-icons md-24">add</i>
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
